import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter, Redirect } from 'react-router';

import Aux from './../hoc/_Aux';
import Chat from './../containers/Chat/Chat';
import Quiz from './../containers/Quiz/Quiz';

import Auth from './../components/Auth/Auth';
import Account from './../components/Account/Account';
import History from './../components/History/History';
import HistoryList from './../components/History/HistoryList/HistoryList';
import Points from './../components/Points/Points';
import HomePage from './../components/HomePage/HomePage';
import ThematicArticleList from './../components/Article/Thematic/ThematicArticleList';
import ArticlesListRenderer from './../components/ArticlesList/ArticlesListRenderer';
import ResetPassword from './../components/ResetPassword/ResetPassword';
import ForgottenUsername from './../components/ForgottenUsername/ForgottenUsername';
import StorePage from './../components/StorePage/StorePage';
import CGU from './../components/CGU/CGU';
import Contact from './../components/Contact/Contact';
import LoadingPage from './../components/Loader/LoadingPage';
import UpdateSystem from '../components/UpdateSystem/UpdateSystem';
import PromotionPopup from '../components/PromotionPopup/PromotionPopup';

//-- Utils
import firebaseApp from './../utils/firebase/firebase';

//-- Actions
import {getCurrentUser} from './../components/user/userActions';

import './App.css';



export class App extends Component {
    
    componentWillMount() {
        //-- We need to recover user information
        if( this.props.user.username === '' && firebaseApp.auth().currentUser !== null ){
            this.props.getCurrentUser();
        }
    }

    render(){
        
        let routes = null;
        //let hideElement = false; 
       
        // defaults routes with no layout    
        routes = (
                <Switch >
                    <Route exact path="/" component={HomePage}/>
                    <Route path="/login" component={Auth} />
                    <Route path="/account/create" component={Account} />
                    <Route path="/reset-password" component={ResetPassword} />
                    <Route path="/forgotten-username" component={ForgottenUsername} />
                    <Route path="/cgu" component={CGU} />
                    <Route path="/contact" component={Contact} />
                    <Route path="/loading" component={LoadingPage} />
                    <Route path="/discover/thematic/:name" component={ThematicArticleList} />
                    <Route path="/discover/article/:slug" component={ArticlesListRenderer} />
                    <Redirect to="/" />
                </Switch >
        );

        // Authentificated user with routes with layout
        if ( this.props.isUserAuthenticated) {

            // if(this.props.match.path.match('/account/')){
            // if(this.props.location.pathname.match('/account')){
            //     hideElement = true; 
            // }
           
            if ( this.props.isSubscriber && !this.props.subcriptionCheckInProgress ) {
                routes= (	
                    <Aux>	
                        <History />	
                        <Points />
                        <Switch >
                            <Route exact path="/" component={HomePage}/>
                            <Route path="/logout" component={Auth} />
                            <Route path="/account/profile" component={Account} />
                            <Route path="/account/update" component={Account} />
                            <Route path="/chat-with-journalist" component={Chat} />
                            <Route path="/account/historique" component={HistoryList} />
                            <Route path="/article/:slug" component={ArticlesListRenderer} />
                            <Route path="/thematic/:name" component={ThematicArticleList} />
                            <Route path="/quizz" component={Quiz} />
                            <Route path="/cgu" component={CGU} />
                            <Route path="/contact" component={Contact} />
                            <Route path="/store" component={StorePage} />

                            <Route path="/loading" component={LoadingPage} />
                            {/* EBE Fix : this is mandatory here when user is already authenticated before (info are retrieved from localStorage) and a default route is needed */} 
                            <Redirect to="/" />
                            
                        </Switch >	
                    </Aux>);	
            } else {	
                routes= (	
                    <Aux>	
                        <History />	
                        <Points />	
                        <Switch >
                            <Route path="/logout" component={Auth} />

                            <Route path="/account/update" component={Account} />	
                            <Route path="/account/historique" component={HistoryList} />
                            <Route path="/account" component={Account} />

                            <Route path="/cgu" component={CGU} />
                            <Route path="/contact" component={Contact} />	
                                                        
                            <Route path="/loading" component={LoadingPage} />
                            {/* <Redirect to="/" />*/}
                            <Redirect to="/account" /> {/* Route "/" must be placed in the last position to work
                                and by using '/' route (it means that every routes will work) and then it acts like a redirect to force the user 
                                to be redirected to account page, that is what we want in this case for unsubscribed user
                            */}
                        </Switch >	
                    </Aux>);	
            }
        }

        // Manage refreshed page
        /*if(!this.props.isAutoAuthentValid){
            // Until auto authentification process is completed, we remove all routes to prevent from redirecting to an irrelevant route
            routes = null;
        }*/
     
        return (
            <div>
                <UpdateSystem />
                <PromotionPopup />
                {routes}
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        isUserAuthenticated : state.auth.isUserSignedIn,
        isAutoAuthentValid : state.auth.isAuthInitialized,
        isSubscriber : state.auth.isSubscriber,
        subcriptionCheckInProgress : state.auth.subcriptionCheckInProgress,
        user: state.user
    }
};

const mapStateToDispatch = dispatch => {
    return {
        getCurrentUser: () => dispatch(getCurrentUser())
    }
}

export default withRouter( connect( mapStateToProps, mapStateToDispatch )(App));


// WEBPACK FOOTER //
// ./src/app/App.js